<template>
    <div style="height: 100%">
      <div style="display: flex; width: 100%">
        <div style="width: 90%; height: 40px">
          <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
            <el-input v-model="formDatas.scpmName" style="width: 140px;" size="mini" placeholder="请输入名称" clearable></el-input>
            <el-select size="mini" v-model="formDatas.spId" clearable @change="partserch" placeholder="请选择项目" style="width: 130px">
              <el-option v-for="item in projectAll || []" :label="item.spName" :value="item.spId" :key="item.spId">
                  <span v-if="item.spStatus==1||item.spStatus==2||item.spStatus==3" style="color: green;">{{ item.spName }}</span>
                  <span v-if="item.spStatus==4" style="color: orange;">{{ item.spName }}</span>
                  <span v-if="item.spStatus==5" style="color: red;">{{ item.spName }}</span>
                </el-option>
            </el-select>
            <el-select size="mini" v-model="formDatas.scpmType" clearable @change="partserch" placeholder="请选择类型" style="width: 130px">
              <el-option label="记录" :value="1" key="1"></el-option>
              <el-option label="里程碑" :value="2" key="2"></el-option>
            </el-select>
            <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
              style="margin-left: 10px">搜索</el-button>
          </el-row>
        </div>
        <div style="width: 10%; height: 40px">
          <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
            <el-button type="success" size="mini" style="margin-right: 20px" @click="BoxOpen">新增</el-button>
          </el-row>
        </div>
      </div>
      <div class="tablemain">
        <div class="tablecss">
          <div style="width: 100%">
            <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData" :max-height="tableHight"
              :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
              :checkbox-option="checkboxOption" row-key-field-name="scpmId" :cellSelectionOption="cellSelectionOption"
              style="width: 100%" :editOption="editOption" />
              <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
          </div>
          <div class="table-pagination">
            <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
              :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="pageNumberChange"
              @on-page-size-change="pageSizeChange" />
          </div>
        </div>
        <!-- 新增 -->
        <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑里程碑' : '新增里程碑'" :before-close="handleClose"
          :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
          <div class="demo-drawer__content" style="height: 90%;">
            <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
              <div style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                <el-form-item label="类型" prop="scpmType">
                    <el-select size="mini" v-model="form.scpmType" clearable @change="partserch" placeholder="请选择类型" style="width: 130px">
                        <el-option label="记录" :value="1" key="1"></el-option>
                        <el-option label="里程碑" :value="2" key="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="里程碑名称" prop="scpmName">
                  <el-input v-model="form.scpmName" style="width: 80%;" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="里程碑描述" prop="scpmRemark">
                  <el-input v-model="form.scpmRemark" type="textarea" style="width: 80%;" placeholder="请输入"></el-input>
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="demo-drawer__footer" style="margin-top: 10px;">
            <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
            <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
              确 定</el-button>
          </div>
        </el-drawer>
      </div>
    </div>
  </template>
  
  <script>
  
  import { getSysCjProjectList,getSysCjProjectMilestoneList,addSysCjProjectMilestone,updateSysCjProjectMilestone,deleteSysCjProjectMilestone } from "../../api/api";
  export default {
    name: "",
    components: {},
    data() {
      return {
        dialog: false,
        edit: false,
        projectAll: [],
        fileList: [],
        form: {
          scpmName: '',
          scpmRemark: '',
          spId: null,
          scpmType: 1,
        },
        rules: {},
        // 未编辑前的值
        lastValue: "",
        // 单元格编辑功能
        editOption: {
          beforeCellValueChange: ({ row, column, changeValue }) => {
            this.beforeCellValChange(row, column, changeValue);
          },
          afterCellValueChange: ({ row, column, changeValue }) => {
            this.afterCellValChange(row, column, changeValue);
          },
        },
        cellSelectionOption: {
          // disble cell selection
          enable: true,
        },
        totalCount: 100,
        pageIndex: 1,
        pageSize: 20,
        selectedRowKeysCollection: [],
        checkboxOption: {
          // 可控属性
          selectedRowKeys: [],
          // 行选择改变事件
          selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
            this.changeSelectedRowKeys(row, isSelected);
          },
          // 全选改变事件
          selectedAllChange: ({ isSelected, selectedRowKeys }) => {
            this.changeSelectAll(isSelected, selectedRowKeys);
          },
        },
        cellStyleOption: {
          headerCellClass: ({ column, rowIndex }) => {
            if (rowIndex === 0) {
              return "table-header-cell-class";
            }
          },
        },
        windheight: "",
        tableHight: 520,
        columns: [
          {
            field: "",
            key: "a",
            title: "序号",
            width: 50,
            align: "center",
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              return ++rowIndex;
            },
          },
          {
            field: "spName",
            key: "spName",
            title: "项目名称",
            width: 160,
            align: "center",
            edit: true,
          },
          {
            field: "scpmName",
            key: "scpmName",
            title: "名称",
            width: 160,
            align: "center",
            edit: true,
          },
          {
            field: "scpmType",
            key: "scpmType",
            title: "类型",
            width: 100,
            align: "center",
            edit: false,
            renderBodyCell: ({ row, column, rowIndex }, h) => {
                          return (
                              <span>
                                  {
                                      row.scpmType == 1 ? <el-tag type="success">记录</el-tag> :  <el-tag type="danger">里程碑</el-tag> 
                                  }
                              </span>
                          );
                      },
          },
          {
            field: "scpmRemark",
            key: "scpmRemark",
            title: "描述",
            width: 200,
            align: "center",
            edit: true,
          },
          { field: "createtime", key: "createtime", title: "创建时间", width: 160, align: "center" },
          { field: "updatetime", key: "updatetime", title: "更新时间", width: 160, align: "center" },
          {
            field: "",
            key: "d",
            title: "操作",
            width: 200,
            align: "center",
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              return (
                <span>
                  <el-button
                    size="mini"
                    type="text"
                    on-click={() => this.handleEdit(row)}
                  >
                    编辑
                  </el-button>
                  <el-button
                    size="mini"
                    type="text"
                    style="color: red"
                    on-click={() => this.handleDelete(row)}
                  >
                    删除
                  </el-button>
                </span>
              );
            },
          },
        ], //表格的列
        tableData: [],
        post: null,
        formDatas: {
          scpmRemark: "",
          scpmType: "",
          currentPage: 1,
          pageSize: 20,
        },
      };
    },
    activated() {
        getSysCjProjectList().then(res => {
            this.projectAll = res.data
        });
        this.getList();
      this.watchFlag = true;
      this.$nextTick(() => {
        this.windheight = this.$store.state.windheight;
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
      });
    },
    watch: {
      "$store.state.windheight"(val) {
        this.$nextTick(() => {
          if (this.watchFlag) {
            this.tableHight = val - 200 - val * 0.04;
          }
        });
      },
    },
    deactivated() {
      this.watchFlag = false;
    },
    created() {
      this.windheight = this.$store.state.windheight
      this.tableHight =  this.windheight - 200 -  this.windheight * 0.04;
      this.getList();
    },
    mounted() { },
    methods: {
      scPathUpfileChange(file) {
          this.$set(this.form, 'scPath', file[0])
          this.$message({
              type: "success",
              message: "上传成功!",
          });
      },
      handleDelete(row){
        this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            const s = {scpmIds:row.scpmId}
            console.log(s);
            deleteSysCjProjectMilestone({scpmIds:row.scpmId}).then(res=>{
              if(res.data){
                this.$message({
              type: "success",
              message: "删除成功!",
            });
           
            this.partserch()
              }
            })
          }).catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          })
      },
      handleEdit(row){
        const data = JSON.parse(JSON.stringify(row))
        this.dialog = true;
        this.edit = true;
        this.$nextTick(()=>{
                  this.form = data;
                  this.form.scPath = data.scPath.split(',')
                  if (data.scPath.length > 0) {
                    this.form.scPath.forEach((item, index) => {
                      const img = {
                        name: item,
                        url: item,
                      }
                      this.$set(this.fileList, index, img)
                    })
  
                  }
              })
      },
      SureBtn() {
        if(!this.edit){
          this.$confirm("是否确定要新增, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.form.spId=this.formDatas.spId;
            addSysCjProjectMilestone(this.form).then(res=>{
              if(res.data){
                this.$message({
              type: "success",
              message: "新增成功!",
            });
            this.handleClose()
            this.getList()
              }
            })
          }).catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          })
        }else{
          this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            updateSysCjProjectMilestone(this.form).then(res=>{
              if(res.data){
                this.$message({
              type: "success",
              message: "编辑成功!",
            });
            this.handleClose()
            this.getList()
              }
            })
          }).catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          })
        }
        
      },
      BoxOpen() {
        if(!this.formDatas.spId){
                this.$message({
                type: "warning",
                message: "请选择项目",
                });
                return;
            }
            this.dialog = true;
  
      },
      // 关闭弹框
      handleClose() {
        this.dialog = false;
        this.edit = false;
        this.$refs['formRef'].resetFields();
      },
      // 修改单元格
      async beforeCellValChange(row, column, changeValue) {
        if (row[column.field] == changeValue) {
          return false;
        }
  
        this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            var jsonObj = {};
            let formData = new FormData();
            formData.append(column.field, changeValue);
            formData.forEach((value, key) => (jsonObj[key] = value));
            jsonObj.scpmId = row.scpmId
            updateSysCjProjectMilestone(jsonObj).then(res=>{
              this.$message({
              type: "success",
              message: "编辑成功!",
            });
            })
           
          })
          .catch(() => {
            this.lastValue = row[column.field];
            this.$nextTick(() => {
              this.tableData.forEach((item) => {
                for (let key in item) {
                  if (key == column.field && item[key] == changeValue) {
                    item[key] = this.lastValue;
                  }
                  console.log(key);
                }
              });
            });
            this.$message({
              type: "info",
              message: "已取消编辑",
            });
            return false;
          });
      },
      afterCellValChange(row, column, changeValue) {
        // console.log(" afterCellValChange", row, column, changeValue);
      },
      resetSelectedRowKeys() {
        console.log(this.checkboxOption.selectedRowKeys,this.selectedRowKeysCollection);
        this.checkboxOption.selectedRowKeys = [];
  
        const selectedRowKeysCollection = this.selectedRowKeysCollection;
  
        if (selectedRowKeysCollection.length) {
          this.tableData.forEach((item) => {
            if (selectedRowKeysCollection.indexOf(item.scpmId) > -1) {
              console.log(item);
              this.checkboxOption.selectedRowKeys.push(item.scpmId);
            }
          });
        }
      },
      changeSelectAll(isSelected, selectedRowKeys) {
        console.log(isSelected,selectedRowKeys);
        this.checkboxOption.selectedRowKeys = selectedRowKeys;
  
        if (isSelected) {
          this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
        } else {
          this.tableData.forEach((item,index) => {
            if (this.selectedRowKeysCollection.indexOf(item.scpmId) > -1) {
              this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item.scpmId), 1);
            }
          });
        }
      },
      changeSelectedRowKeys(row, isSelected) {
        const rowKey = row.scpmId;
  
        if (isSelected) {
          this.checkboxOption.selectedRowKeys.push(rowKey);
          this.selectedRowKeysCollection.push(rowKey);
          console.log( this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
        } else {
          const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
          this.checkboxOption.selectedRowKeys.splice(index, 1);
          this.selectedRowKeysCollection.splice(index, 1);
        }
      },
      pageSizeChange(pageSize) {
      
        this.formDatas.pageSize = pageSize;
        this.partserch();
        
        
      },
      pageNumberChange(pageIndex) {
        console.log(pageIndex);
        this.formDatas.currentPage = pageIndex;
        getSysCjProjectMilestoneList(this.formDatas).then((res) => {
          this.tableData = res.data;
          this.totalCount = res.total;
          this.resetSelectedRowKeys();
        });
      
      },
      partserch() {
        this.formDatas.currentPage = 1;
        getSysCjProjectMilestoneList(this.formDatas).then((res) => {
          this.tableData = res.data;
          this.totalCount = res.total;
          this.resetSelectedRowKeys();
        });
      },
      getList() {
        getSysCjProjectMilestoneList(this.formDatas).then((res) => {
          this.tableData = res.data;
          this.totalCount = res.total;
        });
      },
    },
  };
  </script>
  
  <style>
  .table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
  }
  
  .easetable::-webkit-scrollbar {
    display: none;
  }
  
  .ve-table-container {
    height: auto !important;
  }
  </style>
  